import { z } from "zod";
/** WebSocket oda adları (Prompt 02 §6). */
export const rooms = {
    tenant: (tenantId) => `tenant:${tenantId}`,
    station: (stationId) => `station:${stationId}`,
    user: (userId) => `user:${userId}`,
};
export const WS_EVENTS = {
    /** İstemci → sunucu: bir odaya abone ol */
    subscribe: "subscribe",
    unsubscribe: "unsubscribe",
    /** Sunucu → istemci: alan olayı */
    domainEvent: "event",
};
export const subscribeRequestSchema = z.object({
    room: z.string().regex(/^(tenant|station|user):[0-9a-f-]{36}$/, "Geçersiz oda adı"),
});
export const subscribeResponseSchema = z.discriminatedUnion("ok", [
    z.object({ ok: z.literal(true), room: z.string() }),
    z.object({ ok: z.literal(false), code: z.string(), message: z.string() }),
]);
/** İstemciye giden olay: zarfın hassas olmayan alt kümesi. */
export const realtimeEventSchema = z.object({
    id: z.uuid(),
    type: z.string(),
    version: z.number().int(),
    aggregateType: z.string(),
    aggregateId: z.uuid(),
    stationId: z.uuid().optional(),
    payload: z.record(z.string(), z.unknown()),
    occurredAt: z.string(),
});
//# sourceMappingURL=realtime.js.map